import BaseRenderer from 'diagram-js/lib/draw/BaseRenderer';
import { isAny } from 'bpmn-js/lib/util/ModelUtil';

const HIGH_PRIORITY = 1500;

export class CustomRenderer extends BaseRenderer {
    /**
     * @param {import('diagram-js/lib/core/EventBus').default<null>} eventBus
     * @param {any} bpmnRenderer
     */
    constructor(eventBus, bpmnRenderer) {
        super(eventBus, HIGH_PRIORITY);

        this.bpmnRenderer = bpmnRenderer;
    }

    /**
     * @param {{ labelTarget: any; }} element
     */
    // @ts-expect-error
    canRender(element) {
        // only render tasks and events (ignore labels)
        return isAny(element, ['bpmn:ExclusiveGateway', 'bpmn:Gateway']) && !element.labelTarget;
    }

    /**
     * @param {any} parentNode
     * @param {any} element
     * @override
     */
    drawShape(parentNode, element) {
        element.type = 'bpmn:Gateway';
        return this.bpmnRenderer.drawShape(parentNode, element);
    }
}

CustomRenderer.$inject = ['eventBus', 'bpmnRenderer'];
